import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { useDispatch } from 'react-redux';
import {
  ProductConditionSummary,
  Variant as VariantType,
  VariantGroup,
} from '../../../../types';
import { trackProductVariantClick } from '../tracking';
import { setSelectedVariant } from '../../actions/product';
import RouteContext from '../../../../routes/context';
import { PriceListFilterContext } from '../../price-list-filter-context';
import VariantGroups from '../variant-groups';
import ProductConditions from '../product-conditions';
import { FiltersWrapper } from './styles';

export const ProductFilters: React.VFC<IProductFilterProps> = props => {
  const { variantGroups, categoryId, conditions } = props;
  const { market } = useContext(AppContext);
  const { filters, selectedCondition } = useContext(PriceListFilterContext);
  const dispatch = useDispatch();
  const { dispatch: routeDispatch } = useContext(RouteContext);

  const hasVariantGroups =
    variantGroups &&
    variantGroups.length > 0 &&
    market.productVariantCategories?.find(c => c === categoryId);
  const hasConditions =
    conditions && conditions.filter(c => c.count > 0).length > 0;

  const handleSelectedVariant = (
    group: VariantGroup,
    variant: VariantType | null
  ) => {
    dispatch(setSelectedVariant(variant));
    trackProductVariantClick(group, variant);
    routeDispatch({
      type: 'PRODUCT_VARIANTS',
      variants: variant && variant.id !== 0 ? [variant.id] : null,
      options: { ...filters },
      condition: selectedCondition,
    });
  };

  return hasVariantGroups || hasConditions ? (
    <FiltersWrapper>
      {hasVariantGroups && (
        <VariantGroups
          handleSelectedVariant={handleSelectedVariant}
          variantGroups={variantGroups!}
        />
      )}
      {hasConditions && <ProductConditions conditions={conditions} />}
    </FiltersWrapper>
  ) : null;
};

interface IProductFilterProps {
  variantGroups?: VariantGroup[] | null;
  conditions: ProductConditionSummary[];
  categoryId?: string;
}
